export const Rebate = {
    NotSelect: '— 不選 —',
    KeepUnchanged: '不更新',
    KeepUnchangedStrategyTip: '該子類型的開戶權限保持不變，此處僅配置返佣策略；留空則維持其現有返佣策略。',
    AccountPermission: '開戶權限',
    UpdateLink: '更新鏈接',
    AddLink: '新增鏈接',
    AccountPermissionDesc: '為當前鏈接配置 MT4 / MT5 帳戶等級組合。',
    ClientGroupConfig: '客戶組別配置',
    ClientGroup: '客戶組別',
    SelectLink: '選擇鏈接',
    SelectLinkDesc: '返佣策略根據全部已保存鏈接的子類型去重集合自動生成。',
    NoLink: '暫無鏈接，請在上方「開戶權限」新增',
    LinkNew: '新增鏈接',
    LinkExisting: '現有鏈接',
    DefaultLink: '默認鏈接',
    SubType: '子類型',
    FxValue: '外匯數值',
    MetalValue: '貴金屬數值',
    StrategyEmpty: '請在上方「選擇鏈接」中新增或保留相關子類型',
    RebateStrategyTitle: '返佣策略',
    TopIbStrategyReadonlyTip: '客戶升級頂級IB時，不允許變更返佣策略',
    IsTopIbStrategyReadonlyTip: '客戶為頂級IB時，不允許變更返佣策略',
    UnitNote: '* 所有數值單位以實際協議為準',
    HintSelectAtLeastOne: '請至少選擇一項開戶權限',
    HintDuplicateLink: '已存在相同配置的鏈接',
    HintLinkAdded: '已新增鏈接',
    HintLinkUpdated: '鏈接已更新',
    TopTier: '頂級組別',
    UpgradeTopIbTitle: '客戶升級頂級IB',
    UpgradeToTopAgent: '是否升級為頂級代理',
    SelectTopGroup: '選擇頂級組',
    NoSuperiorAgentTip: '無上級代理，請先綁定後再重試',
    UpgradeSubIbTitle: '客戶升級下級IB',
    UpdateRebateConfigTitle: 'IB更新返佣配置',
    IbConfigAuditApprove: '審核通過：{auditComment}',
    IbConfigAuditReject: '拒絕原因：{auditComment}',
    KycNotPassedTip: '客戶 KYC 尚未全部通過',
    HasPendingTip: '該客戶已有未完結工單，請等待處理完成',
    CheckPendingTip: '正在校驗工單狀態...',
    AlreadyIbTip: '該賬戶的通行證已關聯IB產品,不可重複開通IB',
    RebateExceedTitle: '返佣值校驗未通過',
    RebateExceedDesc: '以下返佣值超過上級代理對應上限，請調整後重新提交：',
    PreviewStrategyTitle: '返佣策略預覽',
    Symbol: '品種組',
    BasicMoney: '基礎返佣',
    AddCommMoney: '加佣返佣',
    AddPointPoint: '加點返佣',
    ColMoney: '金額',
    ColPercentage: '百分比',
    ColPoint: '點',
    HintFillAllValues: '請填寫所有返佣值',
    HintDefaultLinkRequired: '默認鏈接未勾選',
    HintMixedLinkNeedsUpdate: '以下鏈接同時包含不同類別的子類型，請先選中該鏈接並點擊「更新鏈接」後再提交：',
    RebateSettingConflictTip: '返佣設置的金額小於下級或大於上級。 詳細信息如下:',
    ColAction: '操作',
    DeleteStrategyConfirm: '確認刪除該子類型的返佣策略？',
    DeleteLockedTip: '該組別已綁定客戶，不可刪除',
    DeleteLockedByMoveTip: '已有客戶移入該鏈接，不可刪除',
    FilterByLink: '客戶組別名稱',
    FilterPlaceholder: '輸入關鍵詞搜索客戶組別名稱...',
    FilterHint:
        '已選 {selected} / {total} 條鏈接：下方返佣策略僅展示所選鏈接的子類型（已去重），提交時將包含全部鏈接數據',
    ExistingLink: '現有',
    SelectAll: '全選',
    // ── 選擇鏈接 - 設置（賬戶列表 / 賬戶權限 / 客戶移動，meegle 14436933）──
    LinkSetting: '設置',
    LinkSettingTitle: '設置 - {name}',
    LinkSettingNewTip: '新建鏈接尚未創建，暫無賬戶數據',
    AccountListTab: '賬戶列表',
    AccountPermissionTab: '賬戶權限',
    PermissionHistoryTip: '當前查詢結果為歷史數據，不包含此次工單改動',
    AccountSearchPlaceholder: '按賬戶 ID / 姓名搜索',
    JoinTime: '加入時間',
    AllServers: '全部服務器',
    AllBasicTypes: '全部基礎賬戶類型',
    BatchMove: '批量移動',
    MoveTitle: '移動賬戶',
    MoveTarget: '目標鏈接',
    MoveCountTip: '本次移動 {count} 個賬戶：',
    MoveSuccess: '移動成功',
    MoveConfirmTitle: '移動確認',
    MoveConfirmDesc: '確認將以下 {count} 個賬戶移動到新的客戶組別？',
    MoveFromGroup: '原組別：',
    MoveToGroup: '目標組別：',
    MoveConfirmWarning: '移動後賬戶的開戶權限與返佣策略將按目標客戶組別生效，請確認無誤。',
    MoveConfirmBack: '返回修改',
    MoveConfirmOk: '確認移動',
    MoveEffectTip: '移動操作將在工單提交並審批通過後生效',
    MoveCancelledOnDelete: '刪除鏈接已取消 {count} 條待移動',
    HintNoMoveTarget: '沒有可移動到的其它鏈接',
    HintSelectMoveTarget: '請選擇目標鏈接',
    HintMoveTargetEmpty: '移動目標鏈接未配置任何子類型，無法創建，請先配置或更換目標',
    HintMoveTargetDuplicateName: '移動目標鏈接名稱重複，請先改名再提交',
    // ── IB返佣策略頁（需求 7 銷售端查看IB返佣策略詳情）──
    IbStrategyTitle: 'IB返佣策略',
    Platform: 'MT平台',
    BasicAccountType: '基礎賬號類型',
    SymbolGroup: '品種組',
    AllSymbolGroups: '所有品種組',
    AccountIdPlaceholder: '請輸入賬戶ID查詢',
    StrategyAccountPermission: '賬戶權限',
    BasicRebate: '基礎返佣',
    CommissionRebate: '加佣返佣',
    PointRebate: '加點返佣',
    // ── 我的介紹經紀人交易量統計優化 ──
    TitleAggregatedTradeVolume: '合計交易量',
    AggregatedTradeVolumeTip: '下方列表交易量合計',
    OneClickSync: '同步',
    OneClickClear: '一鍵清空',
    ClearConfirm: '確認清空所有返傭策略輸入值？',
    SyncNothing: '請先在該計算規則中填寫返傭值，且其他計算規則存在對應子類型',
    SyncRounded: '部分同步值超出該列小數位，已四捨五入',
};
